import { render } from "./PurchaseOutboxQueueListTableHeader.vue?vue&type=template&id=6ced5014"
import script from "./PurchaseOutboxQueueListTableHeader.vue?vue&type=script&lang=js"
export * from "./PurchaseOutboxQueueListTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__